/* eslint-disable camelcase */

import { IFilterObj, IGridMetrics } from 'src/components/filters';
import { IResponseBase } from 'src/types/response-base';
import {
  FETCH_AS_IS_GRID,
  FETCH_AS_IS_GRID_V2,
  FETCH_AS_IS_SUMMARY_BAR_CHART,
  FETCH_COLOR_GRADIENT_FOR_GRID,
  FETCH_MULTI_YEAR_ESTIMATE,
  FETCH_POTENTIAL_RISK_DATA,
  FETCH_PPG_LEVEL_IMPACT_DATA,
  FETCH_SIMULATION_SUMMARY,
  FETCH_TO_BE_GRID,
  FETCH_TO_BE_GRID_V2,
  GET_SUMMARY_DOWNLOAD_DATA,
  RESET_MULTIYEAR_SIMULATION_TABLE,
  SAVE_MULTIYEAR_ESTIMATE,
  SAVE_POTENTIAL_RISKS_UPSIDES,
  GET_CURRENCY_TOGGLE_DATA,
  GET_CURRENCY_TOGGLE_STATE
} from '../../../../../constants';
import { axios } from '../../../../../lib';
import {
  IColorGradientMapPerToggle
} from '../../common/types/grid-color-gradient-map.model';
import { IGridResponsePayload } from '../../planner_v2/types/grid-response-payload';
import { IGridXToYResponse } from '../../planner_v2/types/grid-x-to-y-response.model';
import {
  IAsIsBarChartDetails,
  ISummaryData
} from '../types/simulation-summary.model';
import { IGridPayload } from '../../planner/types/grid-response-payload';

// api for fetching simulation summary metric data - 133617
export function fetchSummaryData(
  source_id: number,
  simulation_id: number,
  module_id: number,
  filter_inputs: object[],
  currency_toggle?: boolean
) {
  const payload = {
    ...filter_inputs,
    ...(currency_toggle !== undefined && { currency_toggle })

  };
  return axios
    .post<ISummaryData>(
      `${FETCH_SIMULATION_SUMMARY}${source_id}/${module_id}/${simulation_id}/`,
      payload
    )
    .then((response) => {
      // eslint-disable-next-line prefer-const
      let sortedSummaryData = JSON.parse(JSON.stringify(response.data));

      sortedSummaryData.metrics.sort((a, b) =>
        a.placement_order > b.placement_order ? 1 : -1
      );

      sortedSummaryData.modules.sort((a, b) =>
        a.placement_order > b.placement_order ? 1 : -1
      );

      return sortedSummaryData;
    });
}

// API - for fetching potential risk ànd upsides table data
export function fetchPotentialRiskData(
  dataInput: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post(
      `${FETCH_POTENTIAL_RISK_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      dataInput
    )
    .then((response) => response.data);
}

// API - for fetching ppg level impact data
export function fetchPPGLevelImpactData(
  dataInput: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number,
  currency_toggle?: boolean
) {
  const payload: any = {
    ...dataInput,
    ...(currency_toggle !== undefined && { currency_toggle })
  }
  return axios
    .post(
      `${FETCH_PPG_LEVEL_IMPACT_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      payload
    )
    .then((response) => response.data);
}

// API - for fetching multiyear estimate data
export function fetchMultiyearEstimateData(
  dataInput: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post(
      `${FETCH_MULTI_YEAR_ESTIMATE}${sourceId}/${moduleId}/${scenarioId}/`,
      dataInput
    )
    .then((response) => response.data);
}

export function fetchResetMultiyearEstimate(
  dataInput: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post(
      `${RESET_MULTIYEAR_SIMULATION_TABLE}${sourceId}/${moduleId}/${scenarioId}/`,
      dataInput
    )
    .then((response) => response.data);
}

export function saveMultiyearSimulation(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${SAVE_MULTIYEAR_ESTIMATE}${sourceId}/${moduleId}/${scenarioId}/`,
      {}
    )
    .then((response) => response.data);
}

export function savePotentialRisksUpsides(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${SAVE_POTENTIAL_RISKS_UPSIDES}${sourceId}/${moduleId}/${scenarioId}/`,
      {}
    )
    .then((response) => response.data);
}

export function fetchAsIsGridData(
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  filterInputs: IFilterObj[],
  localFilters: IGridMetrics
) {
  const payload: IGridResponsePayload = {
    filter_inputs: filterInputs,
    local_filters: localFilters
  };
  return axios
    .post(`${FETCH_AS_IS_GRID}${sourceId}/${moduleId}/${scenarioId}/`, payload)
    .then<IResponseBase<IGridXToYResponse>>((response) => response.data);
}

export function fetchAsIsGridDataV2(
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  filterInputs: IFilterObj[],
  localFilters: IGridMetrics,
  currency_toggle: boolean
) {
  const payload: IGridPayload = {
    filter_inputs: filterInputs,
    local_filters: localFilters,
    ...(currency_toggle != undefined && { currency_toggle })
  };
  return axios
    .post(
      `${FETCH_AS_IS_GRID_V2}${sourceId}/${moduleId}/${scenarioId}/`,
      payload
    )
    .then<IResponseBase<IGridXToYResponse>>((response) => response.data);
}

export function fetchToBeGridData(
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  filterInputs: IFilterObj[],
  localFilters: IGridMetrics
) {
  const payload: IGridResponsePayload = {
    filter_inputs: filterInputs,
    local_filters: localFilters
  };
  return axios
    .post(`${FETCH_TO_BE_GRID}${sourceId}/${moduleId}/${scenarioId}/`, payload)
    .then<IResponseBase<IGridXToYResponse>>((response) => response.data);
}

export function fetchToBeGridDataV2(
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  filterInputs: IFilterObj[],
  localFilters: IGridMetrics,
  currency_toggle: boolean
) {
  const payload: IGridResponsePayload = {
    filter_inputs: filterInputs,
    local_filters: localFilters,
    ...(currency_toggle != undefined && { currency_toggle })
  };
  return axios
    .post(
      `${FETCH_TO_BE_GRID_V2}${sourceId}/${moduleId}/${scenarioId}/`,
      payload
    )
    .then<IResponseBase<IGridXToYResponse>>((response) => response.data);
}

export function fetchColorGradientForGrid(
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  filterInputs: IFilterObj[],
  localFilters: IGridMetrics
) {
  const payload: IGridResponsePayload = {
    filter_inputs: filterInputs,
    local_filters: localFilters
  };
  return axios
    .post(
      `${FETCH_COLOR_GRADIENT_FOR_GRID}${sourceId}/${moduleId}/${scenarioId}/`,
      payload
    )
    .then<IResponseBase<IColorGradientMapPerToggle>>(
      (response) => response.data
    );
}

export function fetchAsIsBarChartData(
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  filterInputs: IFilterObj[],
  localFilters: IGridMetrics,
  currency_toggle: boolean
) {
  const payload: IGridResponsePayload = {
    filter_inputs: filterInputs,
    local_filters: localFilters,
    ...(currency_toggle != undefined && { currency_toggle })
  };
  return axios
    .post(
      `${FETCH_AS_IS_SUMMARY_BAR_CHART}${sourceId}/${moduleId}/${scenarioId}/`,
      payload
    )
    .then<IAsIsBarChartDetails>((response) => response.data);
}

export function fetchCurrencyToggledata(
  sourceId: number,
  scenarioId: number
) {

  const safeScenarioId = !scenarioId || isNaN(scenarioId) ? 0 : scenarioId;

  return axios
    .get<any>(`${GET_CURRENCY_TOGGLE_DATA}${sourceId}/${safeScenarioId}/`)
    .then((response) => response.data);
}

export function setToggleCurrencystate(
  sourceId: number,
  scenarioId: number,
  isTargetEnabled: boolean
) {
  return axios
    .post(`${GET_CURRENCY_TOGGLE_STATE}${sourceId}/${scenarioId}/`, {
      is_target_enabled: isTargetEnabled
    })
    .then((response) => response.data);
}

export function fetchSummaryDownloadData(
  sourceId: number,
  moduleId: number,
  scenarioId: number,
  scenarioName: string
) {
  return axios
    .post(
      `${GET_SUMMARY_DOWNLOAD_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      {},
      {
        responseType: 'blob'
      }
    )
    .then((response) => {
      const disposition = response.headers['content-disposition'];
      let filename = `${scenarioName}.xlsx`;

      if (disposition) {
        const match = disposition.match(/filename\*=UTF-8''(.+)/);
        if (match) {
          filename = decodeURIComponent(match[1]);
        }
      }
      const href = URL.createObjectURL(response.data);
      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      return {
        data: 'Success'
      };
    });
}
